import React from 'react';
import FilterGroup from '@/components/search/FilterGroup';
import DoubleRangeInput from '@/components/search/DoubleRangeInput';

export default function FilterSidebar(props: {
  options: Partial<Record<string, { key: string; count: number }[]>>;
  query: string | string[] | undefined;
  qs: Record<string, string>;
  priceRange: Record<'min' | 'max', number>;
  onPriceRangeChange: ({ min, max }: { min: number; max: number }) => void;
  haslastMinuteDeals: number;
  hasBundleOffers: number;
  id: 'modal' | 'default';
}) {
  const {
    options,
    query,
    qs,
    priceRange,
    onPriceRangeChange,
    haslastMinuteDeals,
    hasBundleOffers,
    id,
  } = props;

  const getBundleOptions = (
    dealTypes:
      | {
          key: string;
          count: number;
        }[]
      | undefined,
  ) => {
    if (!dealTypes) return [];
    const hasBundle = dealTypes.find(
      (dealType) => dealType.key === 'Bundle Deals',
    );

    if (hasBundle) return dealTypes;
    if (!hasBundle && hasBundleOffers > 0)
      return [{ key: 'Bundle Deals', count: hasBundleOffers }];

    return [];
  };

  const dealsOptions =
    haslastMinuteDeals > 0
      ? [
          { key: 'Last Minute', count: haslastMinuteDeals },
          ...(getBundleOptions(options.dealTypes) as []),
        ]
      : getBundleOptions(options.dealTypes);

  const unwantedbrands = ['?', 'Cobalt', 'OPPO'];

  const brands = options.brand?.filter((b) => !unwantedbrands.includes(b.key));

  return (
    <div className="grid w-full gap-5 border " key={'search'}>
      <FilterGroup name={'dealTypes'} key={'dealTypes'} values={dealsOptions} />
      <FilterGroup
        name={'categories'}
        key={'categories'}
        values={options.categories?.filter((cat) => cat.key !== 'Cobalt')}
      />

      <FilterGroup name={'brand'} key={'brand'} values={brands} />

      <div className="p-5 sm:p-4">
        <DoubleRangeInput
          key={query?.toString()} // When query changes, we reset the search
          range={priceRange}
          values={{
            max: Number(qs.maxPrice),
            min: 0,
          }}
          onChange={onPriceRangeChange}
          id={id}
        />
      </div>
    </div>
  );
}
